<div class="page-body">
    <h1 data-aos="fade-down" data-aos-duration="800">Daily Sketches</h1>
    <div class="info">
        <p><strong>Context</strong><br>Sketches to help document my experience and learning</p>
        <p><strong>Materials/Tools</strong><br>Ink pen, pencil, watercolor</p>
    </div>
    <p>Sketching helps me pay attention to details I might miss throughout my day. When I go to a museum, go travelling, go to school, or commute to work, I take a sketchbook with me and sketch out my ideas and experiences. 

    </p>
    <div class="imagegrid">
        <img class="process" src="assets/fun/sketch2.jpg">
        <img class="process" src="assets/fun/sketch10.jpg">
        <img class="process" src="assets/fun/sketch4.jpg">
        <img class="process" src="assets/fun/sketch5.jpg">
        <img class="process" src="assets/fun/sketch7.jpg">
        <img class="process" src="assets/fun/sketch9.jpg">

    </div>
    <img class="process" src="assets/fun/sketch8.jpg">
    <img class="process" src="assets/fun/sketch1.jpg">
    <img class="process" src="assets/fun/sketch6.jpg">
    

    <a class="next" routerLink="/about">About Page -></a>
</div>
